import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class RoleGuardService implements CanActivate {
  hasPermission: boolean;

  constructor(private authService: MsalService, private messageService: MessageService) { }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const expectedRole = route.data.expectedRole;
    const azureAccount = this.authService.instance.getAllAccounts()[0];

    if (!azureAccount.idTokenClaims['roles']) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'El usuario no tiene roles asociados. Por favor contacte al administrador.' });

      return false;
    }

    this.hasPermission = false;
    expectedRole.forEach(element => {
      if (azureAccount.idTokenClaims['roles'].includes(element)) {
        this.hasPermission = true;
      }
    });

    if (!this.hasPermission) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'You do not have access as expected role is missing. Please ensure that your account is assigned to an app role and then sign-out and sign-in again.' });
      return this.hasPermission;
    }

    return this.hasPermission;
  }
}
